import { render } from "./FooterBar.vue?vue&type=template&id=62f6a344"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/FooterBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62f6a344"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62f6a344', __exports__)) {
    api.reload('62f6a344', __exports__)
  }
  
  module.hot.accept("./FooterBar.vue?vue&type=template&id=62f6a344", () => {
    api.rerender('62f6a344', render)
  })

}


export default __exports__